import { Copy, RotateCw, Trash2 } from "lucide-react";
import { box } from "../../lib/gang";

export const GangControls = ({ item, W, onChange, onDuplicate, onRemove }) => {
  const { bw, bh } = box(item);
  const maxW = item.rot === 90 ? W / item.aspect : W;
  const setW = (v) => onChange({ w: Math.max(0.5, Math.min(maxW, parseFloat(v) || 0.5)) });
  return (
    <div className="space-y-3 rounded-xl border border-[#60A5FA]/40 bg-[#2563EB]/5 p-4" data-testid="gang-controls">
      <p className="truncate text-xs text-slate-400">{item.filename}</p>
      <p className="font-display text-lg font-bold" data-testid="gang-selected-size">{bw.toFixed(2)}" W × {bh.toFixed(2)}" H</p>
      <label className="label">Width (inches)</label>
      <div className="flex gap-2">
        <input type="range" min="0.5" max={maxW} step="0.25" value={item.w} onChange={(e) => setW(e.target.value)} className="w-full accent-[#E5202A]" data-testid="gang-width-slider" />
        <input type="number" min="0.5" step="0.25" value={Number(item.w.toFixed(2))} onChange={(e) => setW(e.target.value)} className="field w-20 !px-2 !py-1.5" data-testid="gang-width-input" />
      </div>
      <div className="flex flex-wrap gap-2 text-sm">
        <button type="button" onClick={() => onChange({ rot: item.rot === 90 ? 0 : 90 })} className="btn-ghost !px-3 !py-1.5 !text-sm" data-testid="gang-rotate-button"><RotateCw className="h-4 w-4" />Rotate</button>
        <button type="button" onClick={onDuplicate} className="btn-ghost !px-3 !py-1.5 !text-sm" data-testid="gang-duplicate-button"><Copy className="h-4 w-4" />Duplicate</button>
        <button type="button" onClick={onRemove} className="flex items-center gap-1 px-2 text-slate-400 hover:text-red-400" data-testid="gang-remove-button"><Trash2 className="h-4 w-4" />Remove</button>
      </div>
    </div>
  );
};
